import { HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DialogService } from 'app/dialogs/dialog.service';
import { WebexService } from 'app/services/webex.service';

declare var webex: any;

@Component({
  selector: 'app-webex-widget',
  templateUrl: './webex-widget.component.html',
  styleUrls: ['./webex-widget.component.scss']
})
export class WebexWidgetComponent implements OnInit {

  isExpanded: boolean = false;
  isMinimized: boolean = false;
  serviceDeskEmails = [];
  constructor(
    private webexService: WebexService,
    private dialogService: DialogService,
    private translateService: TranslateService,
  ) { }

  ngOnInit(): void {
  }

  ngAfterViewInit(){
    this.webexService.continueObservable.subscribe(
      data => {
        if(data == 'webex open'){
          const widgetEl = document.getElementById('webex-widget');
          const accessToken = JSON.parse(localStorage.getItem('tokenWebex'));
          const accessJwtToken = JSON.parse(localStorage.getItem('jwtTokenWebex'));
          const room = JSON.parse(localStorage.getItem('roomWebex'));
          this.serviceDeskEmails = (JSON.parse(localStorage.getItem('userRoomWebex')));
          
          for (let i = 0; i < this.serviceDeskEmails.length; i++) {
            const newMembershipData = {
              "roomId": room.id,
              "personEmail": this.serviceDeskEmails[i],
              "isModerator": false
            }
            const headers = new HttpHeaders({ 'Authorization': accessToken });
            this.webexService.addMembers(headers, newMembershipData).subscribe();
          }

          setInterval(()=>{
            // console.log(document.getElementsByClassName('webex-tab-meet')[0]);
            if(document.getElementsByClassName('webex-tab-meet')[0]){
              document.getElementsByClassName('webex-tab-meet')[0].setAttribute('style','display: none');
              // class="webex-tab-meet widget-space--tabMeet--3jr1H"
            }
          },10);

          try {
            webex.widget(widgetEl).spaceWidget({
              guestToken: accessJwtToken,
              destinationType: 'spaceId',
              destinationId: room.id,
              activities: {
                "files": true,
                "meet": true,
                "message": true,
                "people": true
              },
              initialActivity: 'message',
              secondaryActivitiesFullWidth: true,
              onEvent: (type: any, event: any) => {
                if(event.event == 'created' && event.resource == "messages" && event.data.actorId !== room.creatorId){
                  if(this.isMinimized){
                    document.getElementById('webex-notification-icon').style.display = "block";
                  }
                }

                if(event.event == "read" && event.resource == "rooms" && event.data.actorId == room.creatorId){
                  if(!this.isMinimized){
                    document.getElementById('webex-notification-icon').style.display = "none";
                  }
                }
              }
            });
          }
          catch (error) { console.log(error) }
        }else if(data == 'webex close'){
          document.getElementById('card-webex-widget').style.display = "none";
        }
      }
    )
  }

  onExpand(){
    this.isExpanded = true;
    this.isMinimized = false;
    document.getElementById('card-webex-widget').style.width = "100%";
    document.getElementById('card-webex-widget').style.height = "100%";
    document.getElementById('card-webex-widget').style.bottom = "0px";
    document.getElementById('card-webex-widget').style.right = "0px";
    document.getElementById('webex-notification-icon').style.display = "none";
  }

  onResetSize(){
    this.isExpanded = false;
    this.isMinimized = false;
    document.getElementById('card-webex-widget').style.width = "350px";
    document.getElementById('card-webex-widget').style.height = "580px";
    document.getElementById('card-webex-widget').style.bottom = "10px";
    document.getElementById('card-webex-widget').style.right = "10px";
    document.getElementById('webex-notification-icon').style.display = "none";
  }

  onClose(){
    let msg = this.translateService.instant("WEBEX.COMFIRM_CLOSE_WEBEX_COMPONENT");//TODO: message to confirm
    this.dialogService.openConfirmDialog(msg, "")
    .afterClosed().subscribe(
      confirm => {
        if(confirm){
          document.getElementById('card-webex-widget').style.display = "none";
        }
      }
    )
  }

  onMinimize(){
    this.isExpanded = false;
    this.isMinimized = true;
    document.getElementById('card-webex-widget').style.height = "60px";
    document.getElementById('card-webex-widget').style.width = "350px";
  }

}
